import type { InterventionsListTableRowActionsProps } from "./interventions-list-table-row-actions.type";

import { InterventionDissociate } from "@/features/Interventions/Dissociate";
import InterventionEdit from "@/features/Interventions/InterventionEdit";
import { InterventionAssignButton } from "@/modules/intervention/intervention-assign";
import { InterventionDuplicateButton } from "@/modules/intervention/intervention-duplicate";
import { useListTableRowActions } from "@/modules/list-table-row-actions";
import ModelDeleteButton from "@/modules/model-delete-button";
import ModelDissociateButton from "@/modules/model-dissociate-button";
import ModelEditButtonLegacy from "@/modules/model-edit-button-legacy";
import ModelViewButton from "@/modules/model-view-button";

const InterventionsListTableRowActions = ({
  intervention,
  dissociateInfos,
}: InterventionsListTableRowActionsProps) => {
  const { closePopover } = useListTableRowActions();

  return (
    <>
      <ModelViewButton
        type="text"
        modelKey="intervention"
        item={intervention}
        onClick={closePopover}
      />
      <InterventionAssignButton
        type="text"
        intervention={intervention}
        onClick={closePopover}
        noIcon
      />
      <ModelEditButtonLegacy
        type="text"
        modelKey="intervention"
        item={intervention}
        component={<InterventionEdit interventionId={intervention.id} />}
        onClick={closePopover}
      />
      <InterventionDuplicateButton
        type="text"
        intervention={intervention}
        onClick={closePopover}
      />
      {dissociateInfos && (
        <ModelDissociateButton
          type="text"
          modelKey="intervention"
          item={intervention}
          component={
            <InterventionDissociate
              interventionModel={intervention}
              dissociateField={dissociateInfos.field}
              dissociateModel={dissociateInfos.model}
              invalidateKeys={dissociateInfos.invalidateKeys}
            />
          }
          onClick={closePopover}
        />
      )}
      <ModelDeleteButton
        type="text"
        modelKey="intervention"
        item={intervention}
        onClick={closePopover}
        hideIcon
      />
    </>
  );
};

export default InterventionsListTableRowActions;
